import React, { Component } from 'react';
import PropTypes from 'prop-types';
import difference from 'lodash/difference';
import without from 'lodash/without';

import MessageBlock from '@marvelapp/marvel-ui/message-block';

import FormWrap from 'marketing-website/components/modules/FormWrap';
import { isEmailValid } from 'marketing-website/utils/forms';
import { API_LOGIN } from 'marketing-website/constants/api';
import { fetchApi } from 'marketing-website/utils/fetch';

const fields = [
  {
    name: 'email',
    label: 'Email address',
    placeholder: 'you@example.com',
    errorMsg: 'Please enter a valid email address',
    type: 'email',
  },
  {
    name: 'password',
    label: 'Password',
    placeholder: 'Please enter your password',
    errorMsg: 'Please enter your password',
    type: 'password',
  },
];

const inputFieldNames = fields.map(field => field.name);

export default class SignInForm extends Component {
  static propTypes = {
    redirectTo: PropTypes.string,
    messaging: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      invalidFields: [],
      isPending: false,
      password: '',
      backendErrorMsg: '',
      validFields: [],
    };
  }

  setFieldValue = (e, fieldName) => {
    const value = e.target.value;
    let validFields = [];

    if (this.state.validFields.indexOf(fieldName) !== -1) {
      validFields = without(validFields, fieldName);
      this.setState({
        [fieldName]: value,
        validFields,
      });
    } else {
      this.setState({
        [fieldName]: value,
      });
    }
  };

  validateForm = e => {
    e.preventDefault();
    if (this.isFormValid()) {
      this.logIn();
    }
  };

  isFormValid = () => {
    const { email, password } = this.state;
    const invalidFields = [];

    if (!isEmailValid(email)) {
      invalidFields.push('email');
    }

    if (password.length < 6) {
      invalidFields.push('password');
    }

    const validFields = difference(inputFieldNames, invalidFields);

    this.setState({
      invalidFields,
      backendErrorMsg: '',
      validFields,
    });

    return !invalidFields.length;
  };

  logIn = () => {
    const { email, password } = this.state;
    this.setState({ isPending: true });
    fetchApi('POST', API_LOGIN, {
      email,
      password,
    })
      .then(() => {
        if (typeof window !== 'undefined') {
          window.location.href = this.props.redirectTo;
        }
      })
      .catch(() => {
        this.setState({
          isPending: false,
          backendErrorMsg: 'Invalid combination. Have another go.',
        });
      });
  };

  render() {
    const {
      invalidFields,
      isPending,
      validFields,
      backendErrorMsg,
    } = this.state;

    const redirectTo = this.props.redirectTo;

    const buttonProps = {
      text: 'Sign in',
      color: 'green',
      minWidth: 220,
      tabIndex: 9,
    };

    return (
      <FormWrap
        action={API_LOGIN}
        autocomplete="on"
        backendErrorMsg={backendErrorMsg}
        buttonFullWidth
        buttonProps={buttonProps}
        fields={fields}
        googleButtonText="Sign in with Google"
        invalidFields={invalidFields}
        isPending={isPending}
        isSignIn
        messaging={this.props.messaging}
        redirectTo={redirectTo}
        setFieldValue={this.setFieldValue}
        validateForm={this.validateForm}
        validFields={validFields}
      >
        <MessageBlock type="error" fullWidth>
          <div className="fontSize-m">{backendErrorMsg}</div>
        </MessageBlock>
      </FormWrap>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/SigninForm/index.js